import React from 'react';
import Modal from 'react-responsive-modal';

import { getCurrentResource } from '../../util/tools';

class ConfirmationModalDialog extends React.Component {

	title = '...';
	buttonYesText = '';
	buttonNoText = '';
	maxWidth = null;
	
	confirmMessage = '';
	yesAction = null;
	
	constructor(props) {
		super(props);
		this.state = {isModalOpen: false};

		let resource = getCurrentResource().components.modal.ConfirmationModalDialog;
		this.title = resource.title;		
		this.buttonYesText = resource.buttonYes;
		this.buttonNoText = resource.buttonNo;
	}
	
	openModal = (message, yesAction) => {
		this.confirmMessage = message;
		this.yesAction = yesAction;
		this.setState({isModalOpen: true});
	}
	closeModal = (confirm) => {
		let postAction = confirm ? this.yesAction : null;
		this.setState({isModalOpen: false}, postAction);
	}
	
	getStyleModal() {
		return {
			modal: {
				background: '#ffffff',
				padding: '0px',
				borderRadius: '21px',
				maxWidth: '600px',
				width: '100%',
			},
			closeButton: {
				top: '10px',
				right: '10px',
				fill: '#FF0000',
				outline: 'none',
			},
		};
	}
	getStyleBody() {
		return {
			divMain: {
				marginBottom: '20px',
			},
			divHeader: {
				fontSize: '16pt',
				textAlign: 'center',
				padding: '10px',
				borderRadius: '21px 21px 0 0',
				color: 'blue',
				backgroundColor: '#F0F0F0'
			},
			divForm: {
				marginTop: '10px',
				padding: '30px',
				textAlign: 'center',
				fontSize: '18pt',
				color: 'blue',
			},
			divButtons: {
				marginTop: '7px',
				padding: '10px',
				marginRight: '20px',
				textAlign: 'center'
			}
		};
	}
	
	render() {
		let styleModal = this.getStyleModal();
		if( this.maxWidth )
			styleModal.maxWidth = this.maxWidth;
		return (
			<Modal 
				open={this.state.isModalOpen} onClose={() => {this.closeModal(false)}} center 
				styles={styleModal} closeOnOverlayClick={false} animationDuration={1} 
			>
				{this.renderModalBody()}
			</Modal>
		);
	}

	renderModalBody() {
		let styleBody = this.getStyleBody(); 
		return(
			<div style={styleBody.divMain}>
				{this.renderHeader()}
				{this.renderConfirmMessage()}
				{this.renderButtons()}
			</div>
		);
	}
	renderHeader() {
		let styleBody = this.getStyleBody(); 
		return(
			<div style={styleBody.divHeader}>
				{this.title}
			</div>
		);
	}
	renderConfirmMessage() {
		let styleBody = this.getStyleBody(); 
		return(
			<div style={styleBody.divForm}>
				{this.confirmMessage}
			</div>
		);
	}
	renderButtons() {
		let styleBody = this.getStyleBody(); 
		return (
			<div style={styleBody.divButtons}>
				<button type='button' style={{padding: '5px 20px 5px 20px'}} 
					onClick={()=>this.closeModal(true)}
				>
					{this.buttonYesText}
				</button>
				<button type='button' style={{marginLeft: '200px', padding: '5px 20px 5px 20px'}} 
					onClick={()=>this.closeModal(false)}
				>
					{this.buttonNoText}
				</button>
			</div>
		);
	}
}

export default ConfirmationModalDialog;
